// extracted by mini-css-extract-plugin
export var boxItems = "_bs-1";
export var boxItemsLg = "_bs-2";
export var button = "_bs-7";
export var buttonLg = "_bs-8";
export var filterGroupBox = "_bs-0";
export var icon = "_bs-3";
export var iconSecondary = "_bs-6";
export var iconWrapper = "_bs-4";
export var iconWrapperLg = "_bs-5";